import { sqliteTable, text, integer, real } from "drizzle-orm/sqlite-core";
import { fleetVehicles } from "./vehicles";
import { maintenanceTypes } from "./maintenance-types";

// ============================================================================
// maintenance_schedules — กำหนดการซ่อมบำรุง (recurring)
// ============================================================================
export const maintenanceSchedules = sqliteTable("fleet_maintenance_schedules", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  vehicleId: text("vehicle_id").notNull().references(() => fleetVehicles.id),
  maintenanceTypeId: text("maintenance_type_id").references(() => maintenanceTypes.id),
  intervalKm: integer("interval_km"),
  intervalMonths: integer("interval_months"),
  lastServiceKm: real("last_service_km"),
  lastServiceDate: text("last_service_date"),
  nextDueKm: real("next_due_km"),
  nextDueDate: text("next_due_date"),
  isActive: integer("is_active").notNull().default(1),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type MaintenanceSchedule = typeof maintenanceSchedules.$inferSelect;
export type NewMaintenanceSchedule = typeof maintenanceSchedules.$inferInsert;
